<template lang="pug">
b-modal(
  v-model="isVisible"
  size="xl"
  centered
  hide-footer
  no-close-on-backdrop
  content-class="exception-detail-modal"
  @hidden="$emit('close')"
)
  template(#modal-header="{ close }")
    .modal-header-content
      .d-flex.align-items-center
        b-icon.back-icon(
          icon="arrow-left"
          @click="close"
        )
        h5.modal-title.mb-0.ml-3 {{ modalTitle }}
      b-button.close-btn(
        variant="link"
        @click="close"
      )
        b-icon(icon="x" font-scale="1.5")

  .modal-body-content(v-if="loading")
    .text-center.py-5
      b-spinner(variant="warning" label="Cargando...")
      p.mt-3.text-muted Cargando información...

  .modal-body-content(v-else-if="error")
    .text-center.py-5
      b-icon(icon="exclamation-circle" variant="danger" font-scale="3")
      p.mt-3.text-danger {{ error }}
      b-button(variant="secondary" @click="$emit('close')") Cerrar

  .modal-body-content(v-else-if="exceptionData")
    //- Datos del Cliente y Equipo lado a lado
    b-row.mb-4
      //- Datos del Cliente
      b-col(cols="12" md="8")
        .section-container.h-100
          .section-header
            b-icon.section-icon.mr-2(icon="person-fill")
            h6.mb-0 Datos del Cliente

          .data-grid
            .data-item
              span.data-label.rut-label R.U.T.
              span.data-value {{ exceptionData.datos_cliente.rut }}
            .data-item
              span.data-label Nombre
              span.data-value {{ exceptionData.datos_cliente.nombre }}
            .data-item
              span.data-label Apellido
              span.data-value {{ exceptionData.datos_cliente.apellido }}
            .data-item
              span.data-label Teléfono
              span.data-value {{ exceptionData.datos_cliente.telefono || '-' }}
            .data-item
              span.data-label Correo
              span.data-value {{ exceptionData.datos_cliente.correo }}
            .data-item
              span.data-label Región
              span.data-value {{ exceptionData.datos_cliente.region }}
            .data-item
              span.data-label Comuna
              span.data-value {{ exceptionData.datos_cliente.comuna }}
            .data-item.full-width
              span.data-label Dirección
              span.data-value {{ exceptionData.datos_cliente.direccion }}

      //- Datos del Equipo
      b-col(cols="12" md="4")
        .section-container.h-100
          .section-header
            b-icon.section-icon.mr-2(icon="laptop")
            h6.mb-0 Datos del Equipo

          .data-grid.equipo-grid
            .data-item
              span.data-label.rut-label Nº de Serie
              span.data-value {{ exceptionData.datos_equipo.numero_serie }}
            .data-item
              span.data-label Marca
              span.data-value {{ exceptionData.datos_equipo.marca || '-' }}
            .data-item
              span.data-label Modelo
              span.data-value {{ exceptionData.datos_equipo.modelo || '-' }}

    //- Tabla de Repuestos y Mano de Obra
    .section-container.mb-4
      .section-header
        b-icon.section-icon.mr-2(icon="tools")
        h6.mb-0 Repuestos y Mano de Obra

      div(v-if="exceptionData.repuestos_cotizados && exceptionData.repuestos_cotizados.length > 0")
        b-table(
          :items="exceptionData.repuestos_cotizados"
          :fields="repuestosFields"
          responsive
          striped
          hover
          small
          class="repuestos-table mb-0"
        )
          template(#cell(producto)="{ item }")
            .product-cell
              span.product-code COD: {{ item.part_number }}
              span.product-name {{ item.descripcion }}
          template(#cell(precio_unitario)="{ value }")
            | {{ formatCurrency(value) }}
          template(#cell(precio_total)="{ value }")
            | {{ formatCurrency(value) }}
      .empty-state(v-else)
        p.text-muted.mb-0 No hay repuestos cotizados

    //- Información del Abono (condicional)
    .section-container.mb-4(v-if="exceptionData.info_abono")
      .section-header
        b-icon.section-icon.mr-2(icon="receipt")
        h6.mb-0 Información del Abono

      .abono-container
        b-row
          b-col(cols="12" md="6")
            .abono-grid
              .abono-row
                span.abono-label Sub-Total
                span.abono-value {{ formatCurrency(exceptionData.info_abono.subtotal) }}
              .abono-row
                span.abono-label Costo Envío
                span.abono-value {{ formatCurrency(exceptionData.info_abono.costo_envio) }}
              .abono-row
                span.abono-label IVA
                span.abono-value {{ formatCurrency(exceptionData.info_abono.iva) }}
              .abono-row.total-row
                span.abono-label.font-weight-bold Total
                span.abono-value.font-weight-bold {{ formatCurrency(exceptionData.info_abono.monto_total) }}
          b-col(cols="12" md="6")
            .abono-grid
              .abono-row(v-if="exceptionData.info_abono.descuento > 0")
                span.abono-label Descuento
                span.abono-value.text-success -{{ formatCurrency(exceptionData.info_abono.descuento) }}
              .abono-row
                span.abono-label Monto Mínimo Abono
                span.abono-value {{ formatCurrency(exceptionData.info_abono.monto_minimo_abonar) }}
              .abono-row
                span.abono-label.font-weight-bold Monto Solicitado
                span.abono-value.text-primary.font-weight-bold {{ formatCurrency(exceptionData.info_abono.monto_abona_cliente) }}

    //- Footer con acciones
    .modal-footer-actions
      template(v-if="exceptionData.estado === 'PENDIENTE'")
        b-button.action-btn.btn-approve(
          @click="handleApprove"
          :disabled="actionLoading"
        )
          b-spinner(v-if="actionLoading && currentAction === 'approve'" small)
          span(v-else) Aprobar
        b-button.action-btn.btn-reject(
          @click="handleReject"
          :disabled="actionLoading"
        )
          b-spinner(v-if="actionLoading && currentAction === 'reject'" small)
          span(v-else) Rechazar
        b-button.action-btn.btn-close-modal(
          @click="$emit('close')"
          :disabled="actionLoading"
        ) Cerrar
      template(v-else)
        b-button.action-btn.btn-close-modal(
          @click="$emit('close')"
        ) Cerrar
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ExceptionDetailModal',
  props: {
    exceptionId: {
      type: [Number, String],
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
      loading: false,
      error: null,
      exceptionData: null,
      actionLoading: false,
      currentAction: null,
      repuestosFields: [
        { key: 'producto', label: 'Producto' },
        { key: 'cantidad', label: 'Cantidad', class: 'text-center' },
        {
          key: 'precio_unitario',
          label: 'Precio Unitario',
          class: 'text-right',
        },
        { key: 'precio_total', label: 'Total', class: 'text-right' },
      ],
    }
  },
  computed: {
    modalTitle() {
      if (!this.exceptionData) return 'Detalle de Excepción'
      const tipoLabel = this.exceptionData.tipo
        ? ` - ${this.exceptionData.tipo}`
        : ''
      if (this.exceptionData.estado === 'PENDIENTE') {
        return `Aprobar Excepción OV ${this.exceptionData.ov_id}${tipoLabel}`
      }
      return `Excepción OV ${this.exceptionData.ov_id}${tipoLabel}`
    },
    estadoBadgeVariant() {
      const variants = {
        PENDIENTE: 'warning',
        APROBADO: 'success',
        RECHAZADO: 'danger',
      }
      return variants[this.exceptionData?.estado] || 'secondary'
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.isVisible = val
        if (val && this.exceptionId) {
          this.fetchExceptionDetail()
        }
      },
    },
  },
  methods: {
    ...mapActions('OVStore', ['getExceptionDetail', 'manageException']),

    async fetchExceptionDetail() {
      this.loading = true
      this.error = null
      try {
        this.exceptionData = await this.getExceptionDetail(this.exceptionId)
      } catch (err) {
        console.error('Error fetching exception detail:', err)
        this.error = 'Error al cargar los datos de la excepción'
      } finally {
        this.loading = false
      }
    },

    formatCurrency(value) {
      if (value === null || value === undefined) return '$0'
      return `$${Number(value).toLocaleString('es-CL')}`
    },

    async handleApprove() {
      this.actionLoading = true
      this.currentAction = 'approve'
      try {
        await this.manageException({
          ov_id: this.exceptionData.ov_id,
          estado: 'approved',
        })
        this.$bvToast.toast('Excepción aprobada correctamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true,
        })
        this.$emit('action-completed', 'approved')
      } catch (err) {
        console.error('Error approving exception:', err)
        this.$bvToast.toast('Error al aprobar la excepción', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.actionLoading = false
        this.currentAction = null
      }
    },

    async handleReject() {
      this.actionLoading = true
      this.currentAction = 'reject'
      try {
        await this.manageException({
          ov_id: this.exceptionData.ov_id,
          estado: 'reject',
        })
        this.$bvToast.toast('Excepción rechazada correctamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true,
        })
        this.$emit('action-completed', 'rejected')
      } catch (err) {
        console.error('Error rejecting exception:', err)
        this.$bvToast.toast('Error al rechazar la excepción', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.actionLoading = false
        this.currentAction = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

::v-deep .modal-backdrop {
  background-color: $samtek-grey;

  &.show {
    opacity: 0.5;
  }
}

::v-deep .modal-dialog {
  max-width: 788px;
}

::v-deep .exception-detail-modal {
  width: 788px;
  max-width: 100%;
  background-color: #fff;
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  padding: 20px;
  max-height: 90vh;
  overflow: hidden;
}

::v-deep .modal-header {
  background-color: #fff;
  border-bottom: none;
  padding: 0 0 20px 0;
}

.modal-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.back-icon {
  cursor: pointer;
  color: $samtek-yellow;
  font-size: 1.2rem;
}

.modal-title {
  color: $samtek-black;
  font-weight: 700;
  font-size: 18px;
}

.close-btn {
  color: $samtek-grey;
  padding: 0;
  &:hover,
  &:focus {
    color: $danger-strong;
  }
}

::v-deep .close-btn svg {
  width: 20px;
  height: 20px;
}

.modal-body-content {
  padding: 0;
  overflow-y: auto;
  max-height: calc(90vh - 180px);
}

::v-deep .modal-body-content > .row,
::v-deep .modal-body-content > .section-container {
  margin-bottom: 20px !important;
}

.section-container {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid $table-head-bg;

  h6 {
    color: $samtek-black;
    font-weight: 700;
    font-size: 14px;
  }

  .section-icon {
    color: $samtek-black;
    font-size: 16px;
  }
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  overflow: hidden;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.equipo-grid {
  grid-template-columns: 1fr;
  overflow: hidden;
}

.data-item {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &.full-width {
    grid-column: 1 / -1;
  }
}

.data-label {
  font-size: 12px;
  font-weight: 400;
  color: #8a8a8a;
}

.data-value {
  font-size: 13px;
  font-weight: 700;
  color: $samtek-black;
  word-break: break-word;
  overflow-wrap: break-word;
}

::v-deep .repuestos-table {
  thead th {
    background-color: $table-head-bg;
    color: $samtek-grey;
    border: none;
    font-size: 12px;
    font-weight: 700;
  }

  tbody tr {
    height: 40px;
  }

  tbody td {
    border: none;
    background-color: #fff;
    vertical-align: middle;
    font-size: 13px;
  }

  tbody td:not(:first-child) {
    text-align: right;
  }
}

.product-cell {
  display: flex;
  flex-direction: column;
}

.product-code {
  font-size: 11px;
  color: $samtek-grey;
}

.product-name {
  font-size: 14px;
  color: $samtek-black;
  font-weight: 500;
}

.empty-state {
  padding: 24px;
  text-align: center;
  background: #f9f9f9;
  border-radius: 4px;
}

.abono-container {
  background-color: $center-bg;
  border-radius: 8px;
  padding: 16px;
}

.abono-grid {
  width: 100%;
}

.abono-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid $table-head-bg;

  &:last-child {
    border-bottom: none;
  }

  &.total-row {
    border-top: 1px solid $table-head-bg;
    border-bottom: none;
    padding-top: 12px;
    margin-top: 4px;
  }
}

.abono-label {
  color: $samtek-grey;
  font-size: 13px;
}

.abono-value {
  color: $samtek-black;
  font-size: 13px;
  font-weight: 700;
}

.abono-value.text-primary {
  font-size: 16px;
  font-weight: 700;
}

.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 0 0 0;
  background: #fff;
  border-top: 1px solid $table-head-bg;
  position: sticky;
  bottom: 0;
}

.action-btn {
  height: 45px;
  padding: 0 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
}

.btn-reject {
  background-color: $danger-strong;
  border: none;
  color: #fff;

  &:hover {
    background-color: #e52e2e;
  }

  &:disabled {
    background-color: #ff838383;
  }
}

.btn-approve {
  background-color: #2dc98a;
  border: none;
  color: #fff;

  &:hover {
    background-color: #24a873;
  }

  &:disabled {
    background-color: #2dc98a83;
  }
}

.btn-close-modal {
  background-color: $samtek-yellow;
  border: none;
  color: $samtek-black;

  &:hover {
    background-color: #e5b82a;
  }
}

.text-primary {
  color: $blue-accent !important;
}

.text-success {
  color: #34c38f !important;
}
</style>
